module.exports = __webpack_public_path__ + "static/img/imglayout.24ba6592.svg";